import React, {useEffect, useState} from 'react';
import axios from 'axios';
import SelectPhone from "components/formcomponents/SelectPhone";
import UseContext from "hooks/useContext";
import ApiDatabase from "../../../server";
import {toast} from "react-toastify";
import Button from "components/button";
// import ProgressBar from "components/progressBar/progressBar";
// import {TrophyIcon} from "assets/icons";
// import CardProfileCompletionDashboard from "components/card/dashboard/cardProfileCompletionDashboard";
// import Divider from "components/divider/divider";

const MyAccountContent = () => {
    const {companyData, setCompanyData} = UseContext()
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [validPhone, setValidPhone] = useState(false);
    const [errMsgPhone, setErrMsgPhone] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    
    // Profile completion section - commented out (only shown in dashboard)
    // const [completion, setCompletion] = useState(0);
    // const [isProfile, setIsProfile] = useState(0);
    // const [isRemunerationConditions, setIsRemunerationConditions] = useState(0);
    // const [isLegalInformation, setIsLegalInformation] = useState(0);
    // const [isBonusesExemptions, setIsBonusesExemptions] = useState(0);
    // const [isPayment, setIsPayment] = useState(0);

    // const completionSteps = [
    //     {
    //         title: 'Compte',
    //         link:  '/profil/myAccountCompany',
    //         valid: isProfile,
    //     },
    //     {
    //         title: 'Informations légales',
    //         link:  '/profil/legalInformation',
    //         valid: isLegalInformation,
    //     },
    //     {
    //         title: 'Conditions de rémunérations',
    //         link:  '/profil/modesOfPayments',
    //         valid: isRemunerationConditions,
    //     },
    //     {
    //         title: 'Primes & exonérations',
    //         link:  '/profil/bonusesAndCompensation',
    //         valid: isBonusesExemptions,
    //     },
    //     {
    //         title: 'Paiement',
    //         link:  '/profil/paymentsTerms',
    //         valid: isPayment,
    //     }
    // ];

    // useEffect(() => {
    //     setCompletion(100/completionSteps.length * completionSteps.filter(step => step.valid === 1).length);
    // }, [isProfile, isRemunerationConditions, isLegalInformation, isBonusesExemptions, isPayment]);

    // useEffect(() => {
    //     if (
    //         companyData?.name_commercial &&
    //         companyData?.leader?.firstname &&
    //         companyData?.leader?.lastname &&
    //         companyData?.leader?.mail &&
    //         companyData?.leader?.phone &&
    //         companyData?.location
    //     ) {
    //         setIsProfile(1);
    //     }
    //     if (companyData?.remuneration_hours_conditions?.hours_supp_35 !== undefined &&
    //         companyData?.remuneration_hours_conditions?.hours_supp_43 !== undefined &&
    //         companyData?.remuneration_hours_conditions?.hours_night !== undefined &&
    //         companyData?.remuneration_hours_conditions?.hours_sunday !== undefined &&
    //         companyData?.remuneration_hours_conditions?.holiday_hours_worked !== undefined
    //     ) {
    //         setIsRemunerationConditions(1);
    //     }
    //     if (companyData?.reason_social &&
    //         companyData?.siret &&
    //         companyData?.code_ape &&
    //         companyData?.capital &&
    //         companyData?.staff &&
    //         companyData?.conv_collective
    //     ) {
    //         setIsLegalInformation(1);
    //     }
    //     if (
    //         companyData?.bonus?.basket &&
    //         companyData?.bonus?.travel_allowance &&
    //         companyData?.bonus?.cost_of_living
    //     ) {
    //         setIsBonusesExemptions(1);
    //     }
    //     if (
    //         (companyData?.bank_transfer || companyData?.cheque) &&
    //         companyData?.accounting_contact?.firstname &&
    //         companyData?.accounting_contact?.lastname &&
    //         companyData?.accounting_contact?.mail &&
    //         companyData?.accounting_contact?.phone &&
    //         companyData?.invoice_address
    //     ) {
    //         setIsPayment(1);
    //     }
    // }, [companyData]);

    useEffect(() => {
        if (Object.keys(companyData).length && companyData.location) {
            const abortController = new AbortController();
            
            axios({
                method: 'get',
                url: `${process.env.REACT_APP_API_URL}address/${companyData.location}`,
                withCredentials: true,
                signal: abortController.signal
            })
                .then((res) => {
                    if (res.data) {
                        setAddress(res.data.street + ' ' + res.data.city + ', ' + res.data.postcode + ' ' + res.data.department);
                }
                })
                .catch((err) => {
                    // Ignorer les erreurs d'annulation (cleanup normal)
                    if (err.code !== 'ECONNABORTED' && err.code !== 'ERR_CANCELED' && err.name !== 'CanceledError') {
                console.warn('Erreur lors de la récupération de l\'adresse:', err);
                setAddress('');
                    }
                });
            
            if (companyData?.leader?.phone) {
                setPhone(companyData.leader.phone);
            }
            
            // Cleanup: annuler la requête si le composant se démonte ou si l'effet se relance
            return () => {
                abortController.abort();
            };
        }
    }, [companyData]);

    const handleConfirm = () => {
        setIsSaving(true);
        
        // Sauvegarder le téléphone
        if (phone && phone !== companyData?.leader?.phone) {
            ApiDatabase.postUpdatePhoneCompany({
                id: companyData._id,
                phone: phone
            }, (res) => {
                setIsSaving(false);
                toast.success('Les informations ont été mises à jour avec succès.');
                // Mettre à jour le contexte si nécessaire
                if (setCompanyData) {
                    setCompanyData({
                        ...companyData,
                        leader: {
                            ...companyData.leader,
                            phone: phone
                        }
                    });
                }
            }, (err) => {
                setIsSaving(false);
                console.warn(err);
                toast.error('Une erreur est survenue lors de la mise à jour.');
            });
        } else {
            setIsSaving(false);
            toast.info('Aucune modification à enregistrer.');
        }
    };


    return (
        <div className="w-full px-2 tab:px-4 lg:px-8 py-8">
        <div className="flex flex-col gap-8 max-w-3xl">
            {/* Profile Completion Section - Commented out (only shown in dashboard) */}
            {/* {completion < 100 && (
                <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-col gap-2">
                            <h2 className="text-xl font-semibold text-gray-900">
                                Votre profil est complet à {Math.round(completion)}%
                            </h2>
                            <div className="text-sm text-gray-600">
                                Complétez votre profil pour recruter vos premiers intérimaires sur Jobbiz.
                            </div>
                        </div>
                        
                        <div className="flex items-center gap-3">
                            <div className="flex-1">
                                <ProgressBar progress={completion}/>
                            </div>
                            <div className="flex-shrink-0">
                                <TrophyIcon wh={22}/>
                            </div>
                        </div>

                        {completionSteps.filter(step => step.valid === 0).length > 0 && (
                            <div className="mt-2">
                                <div className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-3">
                                    Étapes à compléter
                                </div>
                                <div className="flex flex-wrap gap-3">
                                    {completionSteps.map((step, key) => {
                                        if (step.valid === 0) {
                                            return (
                                                <CardProfileCompletionDashboard 
                                                    key={key} 
                                                    text={step.title} 
                                                    link={step.link} 
                                                    value={parseInt(100/completionSteps.length)}
                                                />
                                            );
                                        }
                                        return null;
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {completion < 100 && <Divider/>} */}

            {/* Account Information Section */}
            <div className="flex flex-col gap-8">
                <div className="flex flex-col gap-6">
                    <h2 className="text-xl font-medium text-gray-900">Informations de l'entreprise</h2>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                            Nom commercial
                        </label>
                        <input 
                            type="text"
                            disabled
                            value={companyData?.name_commercial || ''}
                            className="w-full max-w-md h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                            Adresse de l'entreprise
                        </label>
                        <input 
                            type="text"
                            disabled
                            className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                            value={address}
                        />
                    </div>
                </div>

                <div className="flex flex-col gap-6">
                    <h2 className="text-xl font-semibold text-gray-900">Contact dirigeant</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                Prénom
                            </label>
                            <input 
                                type="text"
                                disabled
                                value={companyData?.leader?.firstname || ''}
                                className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                            />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                Nom
                            </label>
                            <input 
                                type="text"
                                disabled
                                value={companyData?.leader?.lastname || ''}
                                className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                E-mail
                            </label>
                            <input 
                                type="text"
                                disabled
                                value={companyData?.leader?.mail || ''}
                                className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                            />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                Numéro de téléphone
                            </label>
                            <SelectPhone
                                phoneValue={companyData?.leader?.phone}
                                setPhoneValue={setPhone}
                                setValidPhone={setValidPhone}
                                setErrMsgPhone={setErrMsgPhone}
                            />
                        </div>
                    </div>
                </div>
                
                <div className="flex justify-start">
                    <Button 
                        size="SM" 
                        color="PRIMARY" 
                        onClick={handleConfirm}
                        disabled={isSaving}
                    >
                        {isSaving ? 'Enregistrement...' : 'Confirmer'}
                    </Button>
                </div>
                </div>
            </div>
        </div>
    );
};

export default MyAccountContent;